import { PANEL_KEYS } from '@bingads-webui-campaign-react/wizard-shared-components';
import { FLOWS } from './constants';

export const getAssetsPanels = (flow) => {
  const defaultPanels = [
    PANEL_KEYS.SHORT_HEADLINES,
    PANEL_KEYS.VIDEOS,
  ];

  if (flow === FLOWS.WINDOWS) {
    defaultPanels.push(PANEL_KEYS.PRONG_IMAGES);
    defaultPanels.push(PANEL_KEYS.SPOTLIGHT_IMAGES);
    defaultPanels.push(PANEL_KEYS.LOGOS);
  }

  if (flow === FLOWS.ANDROID || flow === FLOWS.IOS) {
    defaultPanels.push(PANEL_KEYS.DESCRIPTIONS);
    defaultPanels.push(PANEL_KEYS.IMAGES);
  }

  return defaultPanels;
};

export const getAssetsSettingsPanels = (flow) => {
  const panels = getAssetsPanels(flow);

  panels.push(PANEL_KEYS.AUDIENCE_SIGNAL);

  return panels;
};
